import { render, staticRenderFns } from "./NaverShoppingProductConfig.vue?vue&type=template&id=5b9e6c8f&"
import script from "./NaverShoppingProductConfig.vue?vue&type=script&lang=ts&"
export * from "./NaverShoppingProductConfig.vue?vue&type=script&lang=ts&"
import style0 from "./NaverShoppingProductConfig.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports